var chunkMapping = {
	"34": [
		828,
		1557,
		2391,
		2777,
		3580,
		5620,
		5894,
		6744,
		9518,
		9684
	],
	"394": [
		559,
		917,
		1012,
		1335,
		1681,
		1760,
		2147,
		2567,
		2591,
		2710,
		2945,
		2948,
		2951,
		3542,
		4686,
		4963,
		5195,
		6586,
		6708,
		6765,
		7090,
		7113,
		7298,
		7599,
		7693,
		7994,
		8122,
		8491,
		8513,
		8618,
		8739,
		9255,
		9266,
		9493,
		9771
	],
	"576": [
		137,
		2844,
		3991,
		5479,
		5637,
		6467,
		9283,
		9523
	],
	"592": [
		7381
	]
};
var idToExternalAndNameMapping = {
	"137": [
		"default",
		"./register",
		7883
	],
	"559": [
		"default",
		"./Page",
		5087
	],
	"828": [
		"default",
		"./UnboxingPageIntroduction",
		9653
	],
	"917": [
		"default",
		"./icons/Filter",
		5087
	],
	"1012": [
		"default",
		"./Col",
		5087
	],
	"1335": [
		"default",
		"./Text",
		5087
	],
	"1557": [
		"default",
		"./icons/MagnetUnboxing",
		5087
	],
	"1681": [
		"default",
		"./Divider",
		5087
	],
	"1760": [
		"default",
		"./Statistic",
		5087
	],
	"2147": [
		"default",
		"./Menu",
		5087
	],
	"2391": [
		"default",
		"./UnboxingPageHeader",
		9653
	],
	"2567": [
		"default",
		"./hooks",
		9653
	],
	"2591": [
		"default",
		"./Tooltip",
		5087
	],
	"2710": [
		"default",
		"./Row",
		5087
	],
	"2777": [
		"default",
		"./Image",
		5087
	],
	"2844": [
		"default",
		"./icons/Message",
		5087
	],
	"2945": [
		"default",
		"./ButtonWithDropdown",
		5087
	],
	"2948": [
		"default",
		"./Card",
		5087
	],
	"2951": [
		"default",
		"./FilterBar",
		5087
	],
	"3542": [
		"default",
		"./Table",
		5087
	],
	"3580": [
		"default",
		"./UnboxingPageBody",
		9653
	],
	"3991": [
		"default",
		"./icons/Science",
		5087
	],
	"4686": [
		"default",
		"./MenuItem",
		5087
	],
	"4963": [
		"default",
		"./History",
		2551
	],
	"5195": [
		"default",
		"./Space",
		5087
	],
	"5479": [
		"default",
		"./icons/Push",
		5087
	],
	"5620": [
		"default",
		"./UnboxingPageRow",
		9653
	],
	"5637": [
		"default",
		"./icons/Email",
		5087
	],
	"5894": [
		"default",
		"./UnboxingPageCol",
		9653
	],
	"6467": [
		"default",
		"./hooks",
		2551
	],
	"6586": [
		"default",
		"./Tag",
		5087
	],
	"6708": [
		"default",
		"./Panel",
		5087
	],
	"6744": [
		"default",
		"./UnboxingPage",
		9653
	],
	"6765": [
		"default",
		"./Avatar",
		5087
	],
	"7090": [
		"default",
		"./icons/Winner",
		5087
	],
	"7113": [
		"default",
		"./Option",
		5087
	],
	"7298": [
		"default",
		"./charts/Column",
		5087
	],
	"7381": [
		"default",
		"./cWrapper",
		2551
	],
	"7599": [
		"default",
		"./notification",
		5087
	],
	"7693": [
		"default",
		"./Selectors",
		2551
	],
	"7994": [
		"default",
		"./StatisticCard",
		5087
	],
	"8122": [
		"default",
		"./LookEmbed",
		5296
	],
	"8491": [
		"default",
		"./icons/InfoCircle",
		5087
	],
	"8513": [
		"default",
		"./Icon",
		5087
	],
	"8618": [
		"default",
		"./Button",
		5087
	],
	"8739": [
		"default",
		"./Collapse",
		5087
	],
	"9255": [
		"default",
		"./Skeleton",
		5087
	],
	"9266": [
		"default",
		"./Select",
		5087
	],
	"9283": [
		"default",
		"./unboxing-page",
		9653
	],
	"9493": [
		"default",
		"./icons/InfoCircleOutlined",
		5087
	],
	"9518": [
		"default",
		"./UnboxingPageDocumentation",
		9653
	],
	"9523": [
		"default",
		"./icons/AltRoute",
		5087
	],
	"9684": [
		"default",
		"./UnboxingPageCrossSelling",
		9653
	],
	"9771": [
		"default",
		"./GameSelectorUtils",
		2551
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}